module.exports = __webpack_public_path__ + "assets/fonts/45f95f45-2279-4cd5-aec7-520734acc86d.ffe15e7e.woff";